import { Injectable } from '@angular/core';
import { State, Action, StateContext } from '@ngxs/store';

import * as actions from './court-event-modals.actions';
import { BcStateForm } from '@bayclubs/state';
import { CancelBlockedSlotMode, CourtEventModalsStateModel, COURT_EVENT_MODALS_FEATURE_KEY } from './court-event-modals.state.model';
import { BlockedSlotService, CourtBookingService } from '@bayclubs/court-booking-employee-api';
import { CoreFacade } from '../../core/core.module';
import { catchError, tap } from 'rxjs/operators';


const initialState = {
    cancelReasonForm: BcStateForm.Empty(),
    cancelBlockedSlotForm: BcStateForm.Empty()
} as CourtEventModalsStateModel;

@Injectable({ providedIn: 'root' })
@State({ name: COURT_EVENT_MODALS_FEATURE_KEY, defaults: initialState })
export class CourtEventModalsState {

    constructor(
        private blockedSlotService: BlockedSlotService,
        private coreFacade: CoreFacade,
        private courtBookingService: CourtBookingService
    ) {}

    @Action(actions.CancelCourtBookingAction)
    cancelCourtBooking(ctx: StateContext<CourtEventModalsStateModel>, action: actions.CancelCourtBookingAction) {
        const state = ctx.getState();
        const club = this.coreFacade.selectedClub();
        return this.courtBookingService
            .api10ClubIdCourtbookingCourtBookingIdCancelPost({
                clubId: club.id,
                courtBookingId: action.courtBookingId,
                cancelCourtBookingRequest: { cancelReason: state.cancelReasonForm.model.reason }
            })
            .pipe(
                tap(value => {
                    ctx.dispatch(new actions.CancelCourtBookingSuccessAction());
                }),
                catchError(err => {
                    throw err;
                })
            );
    }

    @Action(actions.CancelCourtBookingSuccessAction)
    cancelCourtBookingSuccess(ctx: StateContext<CourtEventModalsStateModel>) {
        ctx.patchState({ cancelReasonForm: BcStateForm.Empty() });
    }

    @Action(actions.CancelBlockedSlotAction)
    cancelBlockedSlot(ctx: StateContext<CourtEventModalsStateModel>, action: actions.CancelBlockedSlotAction) {
        const state = ctx.getState();
        const club = this.coreFacade.selectedClub();
        const cancelFollowing = state.cancelBlockedSlotForm.model.cancelMode === CancelBlockedSlotMode.thisAndFollowing;
        return this.blockedSlotService
            .api10ClubIdBlockedslotBlockedSlotIdCancelPost({
                clubId: club.id,
                blockedSlotId: action.blockedSlotId,
                cancelBlockedSlotRequest: {
                    cancelFollowingOccurrences: cancelFollowing,
                    cancelReason: state.cancelBlockedSlotForm.model.reason
                }
            })
            .pipe(
                tap(value => {
                    ctx.dispatch(new actions.CancelBlockedSlotSuccessAction());
                }),
                catchError(err => {
                    throw err;
                })
            );
    }

    @Action(actions.CancelBlockedSlotSuccessAction)
    cancelBlockedSlotSuccess(ctx: StateContext<CourtEventModalsStateModel>) {
        ctx.patchState({ cancelBlockedSlotForm: BcStateForm.Empty() });
    }
}
